/* =======================================================================
   Knowledge Base — screenshot lightbox. Azure item 416.

   A screenshot is a third of its real size in the article column, and
   less than that in the follow-along drawer once that lands. Clicking one
   opens it as large as the window allows. Closes on backdrop click, the
   ✕, or Escape; the page's "/" search shortcut is suppressed while open.
   ======================================================================= */
import { useEffect, useRef } from 'react';

export default function KbLightbox({ shot, onClose }){
  const closeRef = useRef(null);

  useEffect(() => {
    if (!shot) return undefined;
    const prev = document.activeElement;
    if (closeRef.current) closeRef.current.focus();
    return () => { if (prev && prev.focus) prev.focus(); };
  }, [shot]);

  return (
    <div className={'lb' + (shot ? ' on' : '')} role="dialog" aria-modal="true" aria-label="Enlarged screenshot" onClick={onClose}>
      <button className="lb-x" ref={closeRef} title="Close (Esc)" aria-label="Close" type="button" onClick={onClose}>✕</button>
      {shot && <img src={shot.src} alt={shot.alt} onClick={e => e.stopPropagation()} />}
      <div className="lb-cap">{shot ? shot.cap : ''}</div>
      <div className="lb-hint">Click anywhere or press Esc to close</div>
    </div>
  );
}
